import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { ScreenSizes } from '../../../classes/screen-sizes.class';
import { GalleryStatusColorPipe } from '../../../pipes/gallery-status-color.pipe';
import { GalleryStatusIconPipe } from '../../../pipes/gallery-status-icon.pipe';
import { GalleryStatusNamePipe } from '../../../pipes/gallery-status-name.pipe';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { InferredHoverDirective } from '../../../shared/directives/inferred-hover.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';
import { RelativeTimePipe } from '../../pipes/relative-time.pipe';

@Component({
  selector: 'app-gallery-item',
  templateUrl: './gallery-item.component.html',
  styleUrls: ['./gallery-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InferredHoverDirective,
    SvgComponent,
    RelativeTimePipe,
    GalleryTeaserUrlPipe,
    GalleryStatusIconPipe,
    GalleryStatusColorPipe,
    TooltipDirective,
    GalleryStatusNamePipe,
  ],
})
export class GalleryItemComponent {
  @Input() gallery: GalleryDto;
  @Input() compact: boolean;
  @Input() publicMode: boolean;
  @Input() darkBackground: boolean;
  @Input() showPasswordProtected: boolean;
  inferredHover = signal(false);
  hover = signal(false);

  startHover() {
    if (ScreenSizes.screenSize() !== 'desktop') return;
    this.hover.set(true);
  }

  endHover() {
    this.hover.set(false);
  }
}
